import React from 'react';
import StopwatchCell from './StopwatchCell';
import MultiTouchButton from './MultiTouchButton';

const StopwatchGrid = ({
    grid,
    rows,
    lanes,
    activeStopwatches,
    recordedTimes,
    currentTimes,
    lapTimes,
    onStartRow,
    onStopRow,
    onToggleStopwatch,
    onRestartStopwatch,
    onRecordTime,
    onEditCell,
    onSwapAthlete,
    swapMode,
    firstSwapCell
}) => {
    // Hilfsfunktion um zu prüfen, ob eine Reihe mindestens einen Sportler hat
    const hasAthletesInRow = (row) => {
        return row.some(athlete => athlete !== null && athlete !== undefined);
    };

    return (
        <div className="grid-container" style={{ overflow: 'auto' }}>
            <div className="stopwatch-grid">
                {grid.map((row, rowIndex) => (
                    <div key={rowIndex} className="stopwatch-row">
                        <div className="row-controls">
                            {hasAthletesInRow(row) && (
                                <>
                                    <MultiTouchButton
                                        text="Start/Restart"
                                        type="success"
                                        onClick={() => onStartRow(rowIndex)}
                                        width="100%"
                                        height="80px"
                                        className="multitouch-button--large"
                                    />
                                    <MultiTouchButton
                                        text="Stop"
                                        type="danger"
                                        onClick={() => onStopRow(rowIndex)}
                                        width="100%"
                                        height="40px"
                                        className="multitouch-button--small"
                                    />
                                </>
                            )}
                        </div>
                        
                        <div className="row-cells">
                            {row.map((athlete, laneIndex) => {
                                const key = `${rowIndex}-${laneIndex}`;
                                const isFirstSwapCell = firstSwapCell && 
                                    firstSwapCell.row === rowIndex && 
                                    firstSwapCell.lane === laneIndex;
                                
                                return (
                                    <div key={laneIndex} className={`cell-container ${isFirstSwapCell ? 'first-swap-cell' : ''}`}>
                                        <StopwatchCell
                                            athlete={athlete}
                                            onTimeRecord={onRecordTime}
                                            isActive={activeStopwatches[key]}
                                            times={recordedTimes[key]}
                                            currentTime={currentTimes[key] || 0}
                                            lapTime={lapTimes[key] || 0}
                                            onStart={() => onToggleStopwatch(rowIndex, laneIndex)}
                                            onStop={() => onToggleStopwatch(rowIndex, laneIndex)}
                                            onRestart={() => onRestartStopwatch(rowIndex, laneIndex)}
                                            rowIndex={rowIndex}
                                            laneIndex={laneIndex}
                                            onEdit={() => onEditCell(rowIndex, laneIndex)}
                                            onSwap={() => onSwapAthlete(rowIndex, laneIndex)}
                                            swapMode={swapMode}
                                            isFirstSwapCell={isFirstSwapCell}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StopwatchGrid;
